import { FrameworkConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import packageJson from '../../../package.json';
import appJson from '../../app.json';
import { AppState } from '../../store';
import communicationEngineConfigs from './communicationEngineConfigs';
import cryptographyEngineConfigs from './cryptographyEngineConfigs';
import journeyEngineConfigs from './journeyEngineConfigs';
import personalizationEngineConfigs from './personalizationEngineConfigs';
import prismEngineConfigs from './prismEngineConfigs';
import reduxStateEngineConfigs from './reduxStateEngineConfigs';
import remoteConfigurationEngineConfigs from './remoteConfigurationEngineConfigs';
import templateEngineConfigs from './templateEngineConfigs';

export const frameworkConfigs: FrameworkConfigs<AppState> = {
	appName: appJson.name,
	appId: appJson.id,
	appVersion: `${packageJson.name}@${packageJson.version}`,
	reduxStateEngine: reduxStateEngineConfigs,
	journeyEngine: journeyEngineConfigs,
	personalizationEngine: personalizationEngineConfigs,
	templateEngine: templateEngineConfigs,
	communicationEngine: communicationEngineConfigs,
	prismEngineConfigs: prismEngineConfigs,
	remoteConfigurationEngine: remoteConfigurationEngineConfigs,
	cryptographyEngineConfigs: cryptographyEngineConfigs,
};
